module.exports = __webpack_public_path__ + "static/media/renegades_billy_the_kid.fa275eb5.png";